angular.module("templates")

    .controller("TemplatesListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("TEMPLATES_WRITE");

            $rootScope.title = $filter('translate')('templates.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('templates.title') }
            ];

            $scope.gridOptionsTemplates = {

                pdfTitle: $filter('translate')('templates.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',

                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },

                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        name: 'name', displayName: $filter('translate')('templates.name'), enableFiltering: true, enableHiding: false, enableSorting: true,
                        cellTemplate: '<div><span>{{row.entity.name}}</span> <span ng-if="row.entity.obsolete_template" style="color: #d67b67;">' + $filter('translate')('general.obsolete_template') +'</span></div>'
                    },
                  {
                      name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                          { title: $filter('translate')('general.button_duplicate'), action: 'ng-click="grid.appScope.duplicate(row.entity.id)"', cssIconClass: "fa fa-copy" },
                          { title: $filter('translate')('general.button_edit'), action: 'ui-sref="templates.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                          { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                      ], { cssClass: "pull-right" })
                  },
                ],

                getData: function (options) {
                    return Restangular.all('Templates').getList(options);
                }

            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("templates.edit", { id: rowEntity.id });
            };


            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('templates.button_delete'),
                    message: $filter('translate')('templates.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Templates', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('templates.deleted_success'));
                            $scope.gridOptionsTemplates.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };

            $scope.duplicate = function (id) {
                Restangular.all('Templates').customPOST({}, "DuplicateTemplate", { id: id }).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('templates.create_success'));
                        $scope.gridOptionsTemplates.loadData();
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }

        }])

;